import React, { useMemo } from 'react';
import { CollectionState, FiltersMap, KeyedItem } from '@wix/bex-core';
import { CollectionTableActionsColumn } from '../CollectionTableActionsColumn';
import { ActionsCell } from './ActionsCell';

export interface UseRenderActionsCellColumnParams<T, F extends FiltersMap> {
  sticky?: boolean;
  actionsCell?: ActionsCell<T, F>;
  collection: CollectionState<T, F>;
}

export function useRenderActionsCellColumn<T, F extends FiltersMap>(
  params: UseRenderActionsCellColumnParams<T, F>,
) {
  const { collection, actionsCell, sticky } = params;

  return useMemo(() => {
    if (actionsCell == null) {
      return null;
    }

    return (keyedItem: KeyedItem<T>, index: number) => {
      return (
        <CollectionTableActionsColumn
          index={index}
          sticky={sticky}
          collection={collection}
          keyedItem={keyedItem}
          actionsCell={actionsCell}
        />
      );
    };
  }, [sticky, actionsCell]);
}
